export default __webpack_public_path__ + "static/char-sp02-473425eb02ba57cba1eedecd33f2b84e.webp";